import React, { } from 'react';

function NoPage() {
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">No Page</h1>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    );
}

export default NoPage;
